import { DEFAULT_OG_IMAGE } from '@dupe/common/constants'

export const defaultTitle = `Dupe.com | #1 AI Dupe Finder for Furniture, Fashion & More`
export const description =
  "Save up to 90% on designer dupes. Dupe.com's AI finds furniture, fashion & beauty lookalikes from thousands of stores."

const config = {
  defaultTitle,
  titleTemplate: '%s | Dupe.com',
  description,
  openGraph: {
    title: defaultTitle,
    description: description,
    type: 'website',
    site_name: 'Dupe.com',
    images: [
      {
        url: DEFAULT_OG_IMAGE,
      },
    ],
  },
  twitter: {
    handle: '@dupedotcom',
    site: '@dupedotcom',
    cardType: 'summary_large_image',
  },
}

export default config
